<template>
  <el-container class="RegionManage">
    <!-- <el-card class="tree-card" :body-style="treeCard">
      <el-input
        v-model="filterText"
        placeholder="请输入关键词"
        class="input-with-select"
      >
        <template #prefix>
          <i class="iconfont icon-31sousuo"></i>
        </template>
      </el-input>
      <div class="tree-box">
        <el-tree> </el-tree>
      </div>
    </el-card> -->
    <el-card class="tabs-card">
      <el-form
        :inline="true"
        ref="formRef"
        :model="tableParams"
        class="demo-form-inline"
      >
        <el-form-item label="预警时间" prop="">
          <el-date-picker
            v-model="heightAppear"
            type="daterange"
            format="YYYY-MM-DD"
            value-format="YYYY-MM-DD"
            range-separator="~"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="未抓拍天数(≥天)" prop="startDayNum">
          <el-input
            v-model="tableParams.startDayNum"
            clearable
            placeholder="未抓拍天数"
          ></el-input>
          <!-- <h-selectcode
            type="notout_days"
            v-model="tableParams.startDayNum"
            placeholder="未抓拍天数"
            :clearable="true"
          ></h-selectcode> -->
        </el-form-item>
        <el-form-item label="人员姓名">
          <el-input
            v-model="tableParams.personName"
            clearable
            placeholder="人员姓名"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <h-button type="primary" @click="handlemanSearch">查询</h-button>
        </el-form-item>
      </el-form>
      <div class="container" v-loading="loading">
        <el-empty class="h-card-empty" v-if="paginationTotal == 0"></el-empty>
        <!-- <div class="centerBox" v-else>
          <appear-img
            v-for="(item, index) in appearImgList"
            :key="index"
            :item="item"
            @click="appearImgClick(item)"
          ></appear-img>
        </div> -->
        <div class="centerBox" v-else>
          <div
            class="appearImg"
            v-for="(item, index) in appearImgList"
            :key="index"
          >
            <div class="appeartitle">预警时间:{{ item.taskEndDate }}</div>
            <div class="centerImg">
              <el-image
                v-if="item.prisonInfo && item.prisonInfo.imageUrl"
                style="width: 100%; height: 100%"
                :src="windowUrl + item.prisonInfo.imageUrl"
                fit="cover"
              />
              <img
                v-else
                style="width: 100%; height: 100%"
                src="~@/assets/images/moren.png"
              />
            </div>
            <div class="centerTitle">
              <div class="titleman">
                <span class="titleblue" @click="appearImgClick(item)">{{
                  item.prisonInfo && item.prisonInfo.name
                }}</span>
                <span>{{ item.prisonInfo && item.prisonInfo.sexDict }}</span>
                <span>{{
                  item.prisonInfo && item.prisonInfo.ageTypeDict
                }}</span>
              </div>
              <!-- <div class="titleman shengluehao">
                  {{item.prisonInfo.houseAddress}}
                </div> -->
              <div class="titleman redcolor">
                连续{{ item.notOutDays }}天均未抓拍到此人
              </div>
            </div>
          </div>
        </div>

        <div class="pagination">
          <!-- 分页 -->
          <el-pagination
            v-model:currentPage="currentPage"
            v-model:page-size="tableParams.pageSize"
            :page-sizes="[20, 50, 100, 200]"
            :background="background"
            layout="total, sizes, prev, pager, next, jumper"
            :total="paginationTotal"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </div>
      <el-dialog v-model="oldmanVisible" title="详情" width="43%">
        <personnel-detail
          v-model="oldmanVisible"
          :form="userFormData"
          :status="formStatus"
          @submit="userSubmit"
        ></personnel-detail>
        <!-- <oldManDetails></oldManDetails> -->
      </el-dialog>
    </el-card>
  </el-container>
</template>

<script>
import { defineComponent, reactive, toRefs, watchEffect } from "vue";
import moment from "moment";
import { oldManNotGoOut } from "@/api/communityCare/communityCareApi.js";
// import oldManDetails from "./components/oldManDetails.vue";
export default defineComponent({
  name: "",
  // components: { oldManDetails },
  props: {},
  setup(props) {
    const data = reactive({
      windowUrl: window.imgURL,
      heightAppear: [
        moment().subtract(7, "days").format("YYYY-MM-DD"),
        moment().format("YYYY-MM-DD"),
      ],
      tableParams: {
        startDate: "",
        // personName: '',
        startDayNum: 3,
        endDate: "",
        pageNum: 1,
        pageSize: 20,
      },
      loading: false,
      oldmanVisible: false,
      formStatus: 3,
      appearImgList: [],
      userFormData: {},
      currentPage: 1,
      paginationTotal: 0,
      background: "",
      footHoldItem: {},
    });
    const refData = toRefs(data);
    watchEffect(() => {
      data.tableParams.startDate = data.heightAppear[0];
      data.tableParams.endDate = data.heightAppear[1];
    });
    const timedata = () => {};
    const oldManNotGoOutlist = async () => {
      data.loading = true;
      const res = await oldManNotGoOut(data.tableParams);
      data.loading = false;
      if (res) {
        data.paginationTotal = res.page.totalCount;
        data.appearImgList = res.page.list;
        // = res.page.list.prisonInfo;
      }
      console.log(
        "🚀 ~ file: theOldManLivedForALongTime.vue ~ line 129 ~ oldManNotGoOutlist ~ res",
        res
      );
    };
    oldManNotGoOutlist();
    const handlemanSearch = () => {
      oldManNotGoOutlist();
    };
    // 改变页数
    const handleCurrentChange = (val) => {
      data.tableParams.pageNum = val;
      oldManNotGoOutlist();
    };
    // 相似度照片点击
    const appearImgClick = (item) => {
      data.oldmanVisible = true;
      data.userFormData = item;
      data.formStatus = 3;
      // data.footHoldVisible = true;
      // data.footHoldItem = item;
    };
    const userSubmit = () => {
      oldManNotGoOutlist();
      // tableRef.value && tableRef.value.refresh();
    };

    return {
      ...refData,
      handlemanSearch,
      handleCurrentChange,
      appearImgClick,
      timedata,
      userSubmit,
    };
  },
});
</script>

<style lang="scss" scoped>
.container {
  display: flex;
  flex-direction: column;
  height: 100%;
  .pagination {
    margin-top: 15px;
  }
}
.centerBox {
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fill, 256px);
  grid-template-rows: repeat(auto-fill, 300px);
  grid-gap: 24px 22px;
  justify-content: space-around;
  overflow: auto;
}
.appearImg {
  width: 100%;
  height: 100%;
  // background-color: #ccc;
  border-radius: 10px;
  border: 1px solid;
  border-color: #f1f1f1;
  // padding: 15px 10px;
  .titleblue {
    cursor: pointer;
    color: #0367ff;
  }
  .appeartitle {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    color: #000;
    background: #eee;
    line-height: 32px;
    padding: 0 10px;
  }
  .centerTitle {
    width: 100%;
    // height: 15%;
    color: #333;
    line-height: 26px;

    @include flex-col-c-c;
  }
  .titleman {
    display: flex;
    width: 100%;
    justify-content: space-evenly;
  }
  .centerImg {
    width: 100%;
    height: 68%;
    padding-bottom: 10px;
    // padding: 15px 0;
  }
}
.redcolor {
  color: red;
}
.shengluehao {
  width: 100%;
  display: -webkit-box !important;
  overflow: hidden;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  // overflow: hidden;
  // text-overflow:ellipsis;
  // display:-webkit-box;
  // -webkit-box-orient:vertical;
  // -webkit-line-clamp:2;
}
.appearImg:hover {
  box-shadow: 0 0 10px #333;
}
.RegionManage {
  .tree-card {
    height: 100%;
    width: 300px;
    .input-with-select {
      margin-bottom: 10px;
    }
  }
  .tree-box {
    flex: 1;
    overflow: auto;
    position: relative;
  }
  .tabs-card {
    flex: 1;
    // margin-left: 10px;
    .head {
      display: flex;
    }
    .search {
      margin-left: 1000px;
    }
    .tabs-cards-list {
      .list {
        width: 100%;
        display: flex;
        margin-bottom: 10px;
        .left {
          img {
            width: 100%;
            height: 200px;
          }
        }
        .right {
          width: 100%;
          display: flex;
          margin-left: 15px;
          justify-content: space-between;
          line-height: 30px;
        }
      }
    }
  }
}
</style>